import { Box, Button, Checkbox, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next"
import { DestinationModalProps } from "./types";
import { useStyles } from "./styles";
import { useState } from "react";
import { onChange } from "../../../../../../../../../../utils/types";
import { icons } from "../../../../../../../../../../utils/icons";
import {
    APIProvider,
    AdvancedMarker,
    Map,
    useAdvancedMarkerRef,
} from '@vis.gl/react-google-maps';
import { MapHandler } from "../../../../../mapActivity/mapHandler";
import { NoResponse } from "../../../../../../../../../../components/errors/noResponse";



export const DestinationModal = ({ destinations, destinationSelected, cancel, confirm }: DestinationModalProps) => {

    const styles = useStyles()
    const { t } = useTranslation()
    const API_KEY = process.env.REACT_APP_MAP_APIKEY ?? ''
    const [searchValue, setSearchValue] = useState<string>('')
    const [selectedDestination, setSelectedDestination] = useState<{ id?: number | null; latitude: number; longitude: number; direction: string; name: string } | null>(destinationSelected ?? null);
    const [defaultCenter, setDefatulCenter] = useState<{ lat: number; lng: number; }>({ lat: selectedDestination?.latitude ?? 37.7749, lng: selectedDestination?.longitude ?? -122.4194 })
    const defaultZoom = 14
    const [markerRef, marker] = useAdvancedMarkerRef();
    const [selectedPlace, setSelectedPlace] = useState<google.maps.places.PlaceResult | null>(null);

    const handleInputChange: onChange = (event) => {
        const { value } = event.target;

        setSearchValue(value);
    };

    const filteredDestinations = destinations.filter(item =>
        item.name.toLowerCase().includes(searchValue.toLowerCase().trim())
    );


    return (
        <Box sx={styles.mainContainer}>
            <Box className="child left">
                <Typography sx={styles.title} className="mb">{t('loogbook.titles.destinationRegistered')}</Typography>

                <TextField
                    fullWidth
                    variant="outlined"
                    label="Nombre del destino"
                    name="name"
                    value={searchValue}
                    onChange={handleInputChange}
                    sx={{ mb: 3 }}
                />

                <Box sx={styles.destinationsList}>
                    {filteredDestinations.length > 0 ?
                        filteredDestinations.map(item => (
                            <Box sx={styles.destionationBox}>
                                <Box sx={styles.check}>
                                    <Checkbox
                                        name={item.name}
                                        onChange={({ target }) => {
                                            if (target.checked) {
                                                setSelectedDestination({
                                                    id: item.id,
                                                    latitude: item.latitude,
                                                    longitude: item.longitude,
                                                    direction: item.direction,
                                                    name: item.name
                                                });

                                                setDefatulCenter({
                                                    lat: item.latitude,
                                                    lng: item.longitude,
                                                });
                                            } else {
                                                setSelectedDestination(null);
                                            }
                                        }}
                                        checked={
                                            selectedDestination?.id === item.id
                                        }
                                    />
                                </Box>

                                <Box>
                                    <Typography sx={styles.title}>{item.name}</Typography>
                                    <Typography sx={styles.gerent}>{t('loogbook.titles.gerentDestination', { gerent: item.creator })}</Typography>
                                    <Typography sx={styles.direction}>{item.direction}</Typography>
                                </Box>
                            </Box>
                        ))
                        :
                        <NoResponse label={t('loogbook.noDestination')} />
                    }
                </Box>

                <Box sx={styles.butonsContainer}>
                    <Typography variant="body1" sx={styles.cleanFilters} onClick={cancel}>{t('general.cancel')}</Typography>

                    <Button
                        onClick={() => {
                            confirm({
                                id: selectedDestination?.id,
                                direction: selectedDestination?.direction ?? '',
                                latitude: selectedDestination?.latitude ?? 0,
                                longitude: selectedDestination?.longitude ?? 0,
                                name: selectedDestination?.name ?? ''
                            })
                        }}
                        disabled={!selectedDestination?.id}
                        variant="contained"
                    >{t('general.select')}</Button>
                </Box>
            </Box>

            <Box className="child">
                <Typography sx={styles.title} className="mb">{t('loogbook.titles.preview')}</Typography>

                {selectedDestination?.id ?
                    <Box sx={styles.mapContainer}>
                        <APIProvider apiKey={API_KEY}>
                            <Map
                                mapId={'jasdk12q3'}
                                key={selectedDestination.id}
                                defaultZoom={defaultZoom}
                                defaultCenter={defaultCenter}
                                /*center={defaultCenter} */
                                mapTypeId={'roadmap'}
                                gestureHandling={'greedy'}
                                disableDefaultUI={true}
                                zoomControl={true}
                                fullscreenControl={true}
                                onClick={(e) => { }}
                                style={{ flexGrow: 1 }}
                            >
                                <AdvancedMarker
                                    ref={markerRef}
                                    position={{ lat: selectedDestination.latitude, lng: selectedDestination.longitude }}
                                />

                                <MapHandler place={selectedPlace} marker={marker} />
                            </Map>
                        </APIProvider>
                    </Box>
                    :
                    <Box sx={styles.noActivities}>
                        {icons('pinDrop')}
                        <Typography sx={styles.text}>{t('loogbook.noLocationSelected')}</Typography>
                    </Box>
                }
            </Box>
        </Box>
    )
}